import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch all device brands
   * @param {any} query - The query
   */
  fetchBrands: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/brands`, {
      ...query,
    });
  },
  /**
   * Fetch global brands list
   * @param {any} query - The query parameters
   */
  fetchGlobalBrands: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/global-parameters/brands/list`,
      {
        ...query,
      },
    );
  },
  /**
   * Fetch all device
   * @param {any} query - The query
   */
  fetchAllDevices: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices`, {
      ...query,
    });
  },

  /**
   * Fetch device details
   */
  fetchDeviceDetails: (): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices/device-details`);
  },

  /**
   * Create a new device brand
   * @param {any} data - The data
   */
  createBrand: (data: any): Promise<any> => {
    return postRequest(`${config.devices.ChargersApiUrl}api/admin/v1/brands`, data);
  },

  /**
   * Delete an existing device brand
   * @param {any} id - The id
   * @returns {Promise<any>} Promise resolving with response
   */
  deleteBrand: (id: string): Promise<any> => {
    return deleteRequest(`${config.devices.ChargersApiUrl}api/admin/v1/brands/${id}`);
  },

  /**
   * Create a new device
   * @param {any} data - The data
   */
  addDevice: (data: any): Promise<any> => {
    return postRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices/`, data);
  },
  /**
   * Fetch device by ID
   * @param {any} id - The id
   */
  fetchDeviceById: (id: string): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices/${id}`);
  },
  /**
   * Update an existing device
   * @param {any} id - The id
   * @param {any} data - The data
   * @param {any} isFileUpload - The isFileUpload
   */
  updateDevice: (id: string, data: any, isFileUpload = false): Promise<any> => {
    console.log(data, '---------------------->>');
    return patchRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/devices/${id}`,
      data,
      isFileUpload,
    );
  },
  /**
   * Delete an existing device
   * @param {any} id - The id
   */
  deleteDevice: (id: string): Promise<any> => {
    return deleteRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices/${id}/`);
  },

  /**
   * Fetch device models by brand ID or general
   * @param {any} query - The query
   */
  fetchModels: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/models`, {
      ...query,
    });
  },
  /**
   * Fetch global models list
   * @param {any} query - The query parameters
   */
  fetchGlobalModels: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/global-parameters/models/list`,
      {
        ...query,
      },
    );
  },

  /**
   * Create a new device model
   * @param {any} data - The data
   * @param {boolean} isFileUpload - Whether the request contains file upload
   * @returns {Promise<any>} Promise resolving with response
   */
  createModel: (data: any, isFileUpload = false): Promise<any> => {
    return postRequest(`${config.devices.ChargersApiUrl}api/admin/v1/models`, data, isFileUpload);
  },

  /**
   * Delete an existing device model
   * @param {any} id - The id
   * @returns {Promise<any>} Promise resolving with response
   */
  deleteModel: (id: string): Promise<any> => {
    return deleteRequest(`${config.devices.ChargersApiUrl}api/admin/v1/models/${id}`);
  },

  /**
   * Create a new Connector Rating
   * @param {any} data - The data
   */
  createConnecterRating: (data: any): Promise<any> => {
    return postRequest(`${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings`, data);
  },

  /**
   * Delete an existing connector rating
   * @param {any} id - The id
   * @returns {Promise<any>} Promise resolving with response
   */
  deleteConnectorRating: (id: string): Promise<any> => {
    return deleteRequest(`${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings/${id}`);
  },

  /**
   * Fetch device models by brand ID or general
   * @param {any} query - The query
   */
  connecterRateList: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings`, {
      ...query,
    });
  },
  /**
   * Fetch global connector ratings list
   * @param {any} query - The query parameters
   */
  fetchGlobalConnectorRatings: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/global-parameters/connector-ratings/list`,
      {
        ...query,
      },
    );
  },
  /**
   * Fetch device filters
   * @param {any} query query
   * @returns {any} promise
   */
  deviceFilter: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices/filters`, {
      ...query,
    });
  },
  /**
   * Get brand filters
   * @param {any} query query
   * @returns {any} promise
   */
  brandFilter: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/brands/filters`, {
      ...query,
    });
  },
  /**
   * Get model filters
   * @param {any} query query
   * @returns {any} promise
   */
  modelFilter: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/models/filters`, {
      ...query,
    });
  },
  /**
   * Get connector rating filters
   * @param {any} query query
   * @returns {any} promise
   */
  connectorRatingFilter: (query: QueryParameters = {}): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/connector-ratings/filters`, {
      ...query,
    });
  },
  /**
   * Get charger connector status
   * @returns {any} promise
   */
  connectorStatus: (): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/devices/connector-status-count`,
    );
  },
  /**
   * Fetches connector details for a specific EV charging connector.
   * @param {string} id - Unique identifier of the connector.
   * @returns {any} A promise that resolves with the connector details.
   */
  fetchConnectorData: (id: string): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/devices/connector-details/${id}`,
    );
  },
  /**
   * Fetches advanced device details by ID
   * @param {string} id - The ID of the device
   * @returns {any} A promise that resolves with the advanced device details
   */
  fetchAdvanceDeviceDetails: (id: string): Promise<any> => {
    return getRequest(`${config.devices.ChargersApiUrl}api/admin/v1/devices/${id}`);
  },
  /**
   * Fetch tenant websocket URL by tenant name
   * @param {any} tenantName - The tenantName
   */
  fetchTenantWebsocket: (tenantName: string): Promise<any> => {
    return getRequest(
      `${config.devices.ChargersApiUrl}api/admin/v1/tenant-websocket/${tenantName}`,
    );
  },
};
